import { SimpleGrid } from '@mantine/core'
import MentorCard from '@/components/MentorCard'
import { UserWithMentor } from '@/types/mentor'

export default function MentorGrid({ users }: { users: UserWithMentor[] }) {
  if (!users || users.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <p>No results</p>
      </div>
    )
  }

  return (
    <div style={{ paddingLeft: 'var(--mantine-spacing-xl)', paddingRight: 'var(--mantine-spacing-xl)' }}>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="xl">
        {users.map((user, index) => (
          <MentorCard 
            key={user.id || index} 
            user={user} 
            priority={index < 3} // Prioritize first 3 cards (first row on desktop)
          />
        ))}
      </SimpleGrid>
    </div>
  )
}
